export default {
  dropdown: 5,
  frontImage: 1,
  callout: 20,
  overlay: 50,
  foreground: 100
}
